<template>
    <base-modal
        :title="$t('businessOrders.warehouse.manualSelectionTitle')"
        :show-close="false"
        :config="{ focusFirst: false, closeToClick: false }"
        prevent-full-screen-modals
    >
        <flex-row class="select-warehouse-text">
            <div>{{ $t('businessOrders.warehouse.manualSelectionTextStatement') }}</div>
        </flex-row>
        <row class="select-warehouse-text">
            <div>
                <p> {{ $t('businessOrders.warehouse.manualSelectionTextQuestion') }}</p>
            </div>
        </row>
        <flex-row class="select-warehouse-buttons">
            <div class="col">
                <base-button
                    id="cancel"
                    for-modal
                    @click="cancel"
                >
                    {{ $t('general.cancel') }}
                </base-button>
                <base-button
                    id="select"
                    for-modal
                    :disabled="isLoading"
                    @click="select"
                >
                    {{ $t('businessOrders.warehouse.manualSelectionProceed') }}
                </base-button>
            </div>
        </flex-row>
    </base-modal>
</template>

<script>
import { BaseButton } from '@/components/buttons';
import BaseModal from '@/components/modal/BaseModal';
// eslint-disable-next-line
import { $t } from '@/translations';

export default {
    name: 'BusinessOrderConvertModal',
    components: {
        BaseButton,
        BaseModal,
    },
    props: {
        orderId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        async select() {
            this.isLoading = true;
            this.$parent.$emit('select');
            this.$emit('close');
        },
        cancel() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.select-warehouse-buttons {
    margin-right: -50px;
    margin-bottom: -40px;
    margin-left: -50px;

    .modal-button {
        width: 50%;
    }
}

.select-warehouse-text {
    margin-bottom: 20px;
    text-align: center;

    .p {
        width: 100%;
        text-align: center;
        text-justify: auto;
    }
}
</style>
